<div class="modal active">
  <div class="modal__container">
      <div class="fields">
          <h2>Route Selection</h2>
          <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
            <div class="fields__container">
              <div class="form active">
                <div class="fields__block">
                  <div class="fields__block__section">
                    <div class="table-fields">
                      <div>
                        <label>Create Procedure From Route Segments</label>
                        <table>
                          <thead>
                            <tr>
                              <th>Route Designation</th>
                              <th>Number of Segments</th>
                              <th>Status</th>
                          </thead>
                          <tbody>
                            <tr *ngFor="let route of this.routeSegments | keyvalue" [class.highlighted]="route.value.isSelected" (click)="selectRouteRow(route.value)">
                              <td>
                                <span>{{ route.value.designation }}</span>
                              </td>
                              <td>
                                <span>{{ route.value.segments.length }}</span>
                              </td>
                              <td>
                                <span *ngIf="route.value.continuous">OK</span>
                                <span *ngIf="!route.value.continuous">Continuity error</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <label>Route Vertical Distance Settings</label>
                  <div>
                    <span>Procedure Coordinate Points Elevation</span>
                    <select [(ngModel)]="this.procedureCoordPointElevation">
                      <option value="0">Mean vertical distance</option>
                      <option value="1">Maximum vertical distance</option>
                      <option value="2">Minimum vertical distance</option>
                    </select>
                  </div>
                </div>
                <div class="fields__btn">
                  <button type="submit" class="blue" (click)="createProcedureFromRouteSegment()">Ok</button>
                  <button type="submit" class="blue" (click)="cancel()">Cancel</button>
                </div>
            </div>
            </div>
      </div>
  </div>
</div>
